import { useSettingsStore } from "@/features/settings/hooks/useSettingsStore";
import { resolveAiImageMetadataEnabled } from "@/features/settings/utils/aiImageMetadataSetting";
import { useCurrentUrlSlug } from "@/shared/hooks/useCurrentUrlSlug";

/** 保存設定を維持したまま、現在の板での実効値を返す。 */
export function useAiImageMetadataEnabled(): boolean {
  const configuredValue = useSettingsStore(
    (state) => state.aiImageMetadataEnabled,
  );
  const currentUrlSlug = useCurrentUrlSlug();
  return resolveAiImageMetadataEnabled(configuredValue, currentUrlSlug);
}
